import { driver } from "driver.js";
import "driver.js/dist/driver.css";

/**
 * Login Screen Tour
 * Simple 2-step walkthrough for patient access code entry
 */
export const createLoginTour = () => {
  const driverObj = driver({
    showProgress: true,
    showButtons: ['next', 'close'],
    progressText: '{{current}} of {{total}}',
    
    // Styling to match your therapeutic app theme
    popoverClass: 'movemend-tour-popover',
    
    // Touch-friendly: Easy to dismiss but not by accident
    allowClose: true,
    overlayClickNext: false,
    
    // Smooth animations
    animate: true,
    
    // Disable keyboard navigation to prevent accidental dismissal on tablets
    disableActiveInteraction: false,
    
    // Steps for the login flow
    steps: [
      {
        element: '.codeInputContainer',
        popover: {
          title: '👋 Welcome!',
          description: 'Enter the 6-digit access code given to you by your therapist here.',
          side: 'bottom',
          align: 'center'
        }
      },
      {
        element: '#patient-enter-button',
        popover: {
          title: 'Select Enter',
          description: 'Once you\'ve entered your 6-digit code, press this button to continue to your personalized dashboard.',
          side: 'top',
          align: 'center'
        }
      }
    ],
    
    // Callbacks
    onDestroyStarted: () => {
      // Don't save completion - patients are renewed each session
      driverObj.destroy();
    }
  });

  return driverObj;
};

/**
 * Check if user should see the tour
 * Always returns true for patient login since patients are renewed each session
 */
export const shouldShowLoginTour = () => {
  return true; // Always show for patients
};

/**
 * Start the login tour
 * Shows every time since patients are renewed each session
 */
export const startLoginTour = () => {
  const tour = createLoginTour();
  // Small delay to ensure DOM is fully rendered
  setTimeout(() => {
    tour.drive();
  }, 500);
};

/**
 * Force show the tour (for help button or testing)
 */
export const showLoginTour = () => {
  const tour = createLoginTour();
  setTimeout(() => {
    tour.drive();
  }, 300);
};
